import { createActions } from 'reduxsauce';

var _createActions = createActions({
  foodCategoryChange: function foodCategoryChange(foodCategory) {
    return {
      type: 'FOOD_CATEGORY_CHANGE',
      foodCategory: foodCategory
    };
  }
}),
    Creators = _createActions.Creators,
    Types = _createActions.Types;

export default {
  Creators: Creators,
  Types: Types
};